<template>
  <div class="button-container">
    <FhButton
      variant="tertiary"
      data-test-id="fh-button-copy"
      :icon="copy"
      :size="props.size"
      :disabled="props.previewMode"
      @click="handleCopyLink"
    >
      {{ T('Copy link') }}
      <div v-if="isVisibleTooltip" class="tooltip text-small">
        {{ T('Copied to clipboard') }}
      </div>
    </FhButton>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { FhButton } from '@fareharbor-com/beacon-vue';
import { copy } from '@fareharbor-com/beacon-vue/icons';
import { copyTextToClipboard, debounce } from './utils';
import { track } from '../../../scripts/mixpanel';

const props = defineProps({
  previewMode: {
    type: Boolean,
    default: false,
  },
  isSignedForm: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'sm',
  },
});

const isVisibleTooltip = ref(false);

const debouncedHideTooltip = debounce(() => {
  isVisibleTooltip.value = false;
}, 4000);

const handleCopyLink = () => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('source', 'copy-link');

  copyTextToClipboard(
    `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`,
  );

  isVisibleTooltip.value = true;

  if (props.isSignedForm) {
    track('click-fh-waiver-form-copy-link-signed');
  } else {
    track('click-fh-waiver-form-copy-link-not-signed');
  }

  debouncedHideTooltip();
};
</script>

<style scoped lang="scss">
.button-container {
  position: relative;
  width: fit-content;
}

.tooltip {
  width: max-content;
  background-color: var(--fh-color-bg-neutral-strong-active);
  color: var(--fh-color-text-inverted);
  text-align: center;
  border-radius: var(--fh-border-md);
  padding: 2px 5px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  box-shadow: 0px 4px 8px 0px #00000033;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--fh-color-bg-neutral-strong-active) transparent
      transparent transparent;
  }
}
</style>
